document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    if (e.target
            && e.target.closest('.collapse, .collapse-solid, .collapse-simple')
    ) {
      if (!e.target.closest('.prevent-collapse')) {
        e.preventDefault();
        const collapse = e.target.closest('.collapse, .collapse-solid, .collapse-simple');
        if (collapse.getAttribute('data-collapse')) {
          const element = document.querySelector(collapse.getAttribute('data-collapse'));
          if (element) {
            element.classList.toggle('show');
          }
          return;
        }
        collapse.classList.toggle('show');
      }
    }
  });

  // product description
  const productDesc = document.querySelector('.pProducts-main__header-content.expand');

  if (productDesc) {
    productDesc.addEventListener('click', () => {
      productDesc.classList.toggle('open');
    })
  }
});
